import $ from 'jquery';
import { useState } from 'react';

const SideBar = ({ contactUsInfo }) => {

    const [myLan, setMyLan] = useState('Fa')
    // console.log(contactUsInfo);
    // contactUsInfo= props.contactUsInfo;

    function menuToggleFunc() {
        $(".menu-toggle").toggleClass('open');
        // $('.menu-toggle').toggleClass('header-mob-show');
        $('.menu-toggle-darck').toggleClass('menu-toggle-darck-active');
        $('.header').toggleClass('header-mob-show');
        // console.log("btn");
    }

    function changeLanguage(param) {
        var myLan = (param === "E") ? 'En' : 'Fa'
        localStorage.setItem("language", (myLan));
        setMyLan(localStorage.getItem("language"))
    }

    return (
        <div className='sidebar'>
            {/* <!-- start header --> */}
            <header className="header">

                <div className="header-top text-center">
                    <div className="text-start">
                        <div className="header-lng d-none d-inline-block">
                            <span className={localStorage.getItem("language") === "En" ? "lan-btn active" : "lan-btn"} onClick={() => changeLanguage("E")}>En</span>
                            <span className={localStorage.getItem("language") === "Fa" ? "lan-btn active" : "lan-btn"} onClick={() => changeLanguage("F")}>Fa</span>
                        </div>
                    </div>
                    <div className="header-img">
                        {contactUsInfo?.admin.image != null ? (
                            <img src={`https://amirsabit.4api.ir/uploads/Admin/Image/${contactUsInfo?.admin.image}`} alt="" title="" className="img-fluid" />
                        ):<img src={`https://amirsabet.ir/amirsabet_resume.pdf`} alt="" title="" className="img-fluid" />
                        }
                    </div>
                    <div className="header-titles">
                        <h2 className="name">{contactUsInfo?.admin.title2}</h2>
                        <h3 className="">{contactUsInfo?.admin.title1}</h3>
                    </div>
                </div>
                <div>
                    <ul className="main-menu">
                        <li>
                            <a href="#about-me" className="nav-anim active">
                                <i className="fal fa-user"></i>
                                <span className="link-text">درباره من</span>
                            </a>
                        </li>
                        <li>
                            <a href="#resume" className="nav-anim">
                                <i className="fal fa-graduation-cap"></i>
                                <span className="link-text">رزومه</span>
                            </a>
                        </li>
                        <li>
                            <a href="#portfolio" className="nav-anim">
                                <i className="fal fa-briefcase"></i>
                                <span className="link-text">نمونه کارها</span>
                            </a>
                        </li>
                        <li>
                            <a href="#blog" className="nav-anim">
                                <i className="fal fa-book"></i>
                                <span className="link-text">وبلاگ</span>
                            </a>
                        </li>
                        <li>
                            <a href="#contact" className="nav-anim">
                                <i className="fal fa-envelope"></i>
                                <span className="link-text">ارتباط با ما</span>
                            </a>
                        </li>
                    </ul>
                </div>
                <div className="header-social-icon">
                    <ul className="d-inline-flex justify-content-center">
                        <li><a href="#"><i className="fab fa-instagram "></i></a></li>
                        <li><a href="#"><i className="fab fa-telegram"></i></a></li>
                        <li><a href="#"><i className="fab fa-whatsapp"></i></a></li>
                        <li><a href="#"><i className="fab fa-linkedin-in"></i></a></li>
                    </ul>
                </div>
                <div className="header-info d-none d-lg-block">
                    <a href="#" className="phone d-block color-100">{contactUsInfo?.admin.phone}</a>
                    <a href="#" className="email d-block color-100">{contactUsInfo?.admin.email}</a>
                </div>
                <a href={`https://amirsabet.ir/amirsabet_resume.pdf`} className="btn-page d-none d-lg-block">دانلود رزومه</a>
                <div className="arrow-btn text-center">
                    <button className="arrow-btn-next bg-transparent d-block mx-auto border-0"><i className="fal fa-chevron-right"></i></button>
                    <button className="arrow-btn-prev bg-transparent d-block mx-auto border-0"><i className="fal fa-chevron-left"></i></button>
                </div>
            </header>
            {/* <!-- end header --> */}
            <button className="menu-toggle border-0 d-lg-none" onClick={menuToggleFunc} >
                <span></span>
                <span></span>
                <span></span>
            </button>
        </div>
    )
}

export default SideBar;